var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field"},[_c('input',{ref:"input",staticClass:"input",attrs:{"disabled":_vm.flagDisabled,"type":"tel","id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":_vm.initialValue}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2143e4d7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/utils/MaskMoney.vue
// module id = a7jO
// module chunks = 1 2